
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.14 11.86L3.36 14.65C3.17 14.85 3.17 15.16 3.36 15.36L6.14 18.15C6.45 18.47 6.99 18.24 6.99 17.8V16H13C13.55 16 14 15.55 14 15C14 14.45 13.55 14 13 14H6.99V12.21C6.99 11.76 6.45 11.54 6.14 11.86ZM20.65 8.64997L17.87 5.85997C17.56 5.53997 17.02 5.76997 17.02 6.20997V7.99997H11C10.45 7.99997 10 8.44997 10 8.99997C10 9.54997 10.45 9.99997 11 9.99997H17.01V11.79C17.01 12.24 17.55 12.46 17.86 12.14L20.64 9.34997C20.84 9.15997 20.84 8.83997 20.65 8.64997Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-swap-horiz`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSwapHoriz

    ```js
    <b-new-b-icon-swap-horiz />
    ```
</docs>


